import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AuthService } from '../../services/authService';
import { AccountAPI } from '../../services/accountAPI';
import { UserMessageService } from '../../services/userMessageService';

@inject(AuthService, Router, AccountAPI, UserMessageService)
export class AffiliateListCustomElement {
  constructor(authService, router, accountApi, userMessageService) {
    this.authService = authService;
    this.router = router;
    this.accountApi = accountApi;
    this.userMessageService = userMessageService;

    this.selectedMonth = null;

    this.monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];
  }

  activate(accountOwnerUserId) {
    this.accountOwnerUserId = accountOwnerUserId;
    this.date = null;
    this.dataList = null;
    this.count = null;
    this.limit = 10;
    this.page = 1;
    this.sortBy = 'LAST_NAME';
    this.sortDir = 'ASC';
    this.totalMonthlyRevenue = 0.0;
    this.load();
  }

  load() {
    this.loading = true;
    this.dataList = null;
    this.date = null;
    var month = null;
    var year = null;
    if(this.selectedMonth) {
      var temp = this.selectedMonth.split(' ');
      year = temp[0];
      month = temp[1];
    }
    this.accountApi.getAffiliateList(
      month,
      year,
      this.page,
      this.limit,
      this.sortBy,
      this.sortDir,
      this.authService.getUser().token,
      this.saveLoadSuccess.bind(this),
      this.saveLoadError.bind(this)
    );
  }

  saveLoadSuccess(data) {
    this.loading = false;
    this.setData(data);
  }

  saveLoadError(msg) {
    this.userMessageService.setUserError('user', msg);
    this.loading = false;
  }

  setData(data) {
    this.date = data.date;
    this.dataList = data.list;
    this.count = data.count;
    this.pages =  Math.floor(this.count / this.limit);
    this.pages = this.pages * this.limit <= this.count ? this.pages + 1 : this.pages;
    let totalMonthlyRevenue = data.list.map((x) => Number(x.monthly_revenue || 0)).reduce((x, y) => x + y, 0) / 100;
    this.totalMonthlyRevenue = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD'}).format(totalMonthlyRevenue || 0);
    this.dateRange = data.dateRange;
    
  }

  columnClicked(name) {
    if (this.sortBy === name) {
      if (this.sortDir === 'ASC') {
        this.sortDir = 'DESC';
      } else {
        this.sortDir = 'ASC';
      }
      this.load();
    } else {
      this.sortBy = name;
      this.sortDir = 'DESC';
      this.load();
    }
  }

  prev() {
    if (this.page > 1) {
      this.page--;
      this.load();
    }
  }

  next() {
    if (this.page < this.pages) {
      this.page++;
      this.load();
    }
  }

  dateChanged() {
    this.load();
  }
}
